import * as designationService from '../../services/designation.service';


const state = {
    designationSingle:{},
    designationPaginate:{},
    designationPaginateData:{},
    designationDropdown:[],
};

const getters = {
    getDesignationSingle:state => (state.designationSingle),
    getDesignationPaginate:state => (state.designationPaginate),
    getDesignationPaginateData:state => (state.designationPaginateData),
    getDesignationDropdown:state => (state.designationDropdown),
};

const actions = {
    async fetchDesignationSingle({ commit }, id){
      try {
          const response = await designationService.single(id);
          commit('setDesignationSingle', response.data);
      } catch (error) {
          console.log('something wrong - fetchDesignationSingle', error);
      }
    },

    async fetchDesignationPaginate({ commit }, obj){
      commit('setDesignationPaginate', obj)
      try {
          const response = await designationService.listPage(obj);
          commit('setDesignationPaginateData', response.data);
      } catch (error) {
          console.log('something wrong - fetchDesignationPaginate', error);
      }
    },

    async fetchDesignationDropdown({ commit }, obj){
      try {
          const response = await designationService.dropdown();
          commit('setDesignationDropdown', response.data);
      } catch (error) {
          console.log('something wrong - fetchDesignationDropdown', error);
      }
    },
};

const mutations = {
  setDesignationSingle:(state, res) => (
      state.designationSingle =  res
  ),
  setDesignationPaginateData:(state, res) => (
    state.designationPaginateData =  res
  ),
  setDesignationPaginate:(state, res) => (
      state.designationPaginate =  res
  ),
  setDesignationDropdown:(state, res) => (
    state.designationDropdown =  res
  )
};

export default{
    state,
    getters,
    actions,
    mutations,
}
